import { Nullable } from 'global';
import { Path } from 'react-hook-form';
import { UseFormReturn } from 'react-hook-form/dist/types/form';
import { CriteriaValue } from 'modules/jsonRulesCriterias/businessCriteria/types';
import { ListingForm } from 'components/shared/TableListing/types';

export interface TierTableContext {
  loading: boolean;
  handleRemoveRow: (index: number) => void;
  form: UseFormReturn<ListingForm<TierEntity>>;
}

export type TierId = string;

export interface TierEntity {
  name: string;
  color: string;
  description: string;
  criteria: Nullable<Record<string, Omit<CriteriaValue, 'fact' | 'isRequiredToQuote'>>>;
}

export type FormCriteriaPath = Path<ListingForm<TierEntity>>;

export interface TierCriteria {
  isActive: boolean;
  id: Nullable<string>;
}

export enum TierEntityName {
  Prime = 'Prime',
  NearPrime = 'Near-Prime',
  MidTier = 'Mid-Tier',
  Subprime = 'Subprime',
  NotQualified = 'Not qualified',
}
